export default class FramesAnimation{
    
    constructor(el){
        this.step = 30;
        this.elem = el;
        this.lastScrollTop = 0;
        this.scrollTop = 0;
        this.elem = el;
        if (this.elem ){
            this.frames = this.elem.querySelectorAll('.frame');
            this.init();
        }
    }

    init(){
        window.addEventListener('load', (e) => {
            this.frames.forEach(frame => {
                if (frame.dataset.src){
                    let imgSrc = frame.dataset.src;
                    frame.setAttribute('src', imgSrc);
                }
            });
        });
        window.addEventListener('scroll', (e) => {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        });
        window.requestAnimationFrame(() => {
            this.animate();
        });
    }
    animate(){
        const label = Math.min(Math.floor(this.scrollTop/30) + 1, 25);
        if (label < this.frames.length){
            this.frames.forEach((frame, index) => {
                if (index != label){
                    frame.classList.remove('active');
                }
            });
            this.frames[label].classList.add('active');
        }
        this.lastScrollTop = this.scrollTop <= 0 ? 0 : this.scrollTop;
        window.requestAnimationFrame(() => {
            this.animate();
        });
    }

}